import Vue from 'vue'
import Router from 'vue-router'
import Home from './pages/Home.vue'

Vue.use(Router)


import StrategyManager from '@/pages/strategy_manager/StrategyManager'
import VaultManager from '@/pages/vault_manager/VaultManager'
import RoleManager from '@/pages/role_manager/RoleManager'
import ApyDashboard from '@/pages/apy_dashboard/ApyDashboard';


let router = new Router({
	mode: 'hash',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			name: 'home',
			component: Home,
			redirect: '/admin/role',
			children: [
				{
					path: 'admin/strategy',
					name: "strategy",
					component: StrategyManager,
				},
				{
					path: 'admin/vault',
					name: "strategy",
					component: VaultManager,
				},
				{
					path: 'admin/role',
					name: "role",
					component: RoleManager,
				},
				{
					path: 'apy-dashboard',
					name: 'apy-dashboard',
					component: ApyDashboard
				}
			]
		},
	]
})

router.beforeEach((to, from, next) => {
	console.log(from, to)
	return next()
})

export default router
